import { Card, Stack, Textarea } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { httpPostGraphql } from "shared/api/httpClient";
import { PropertyBadge } from "shared/components/global/PropertyBadge";
import { composeFormStateToDraftInfoInput, useComposeFormContext } from "shared/components/message/compose/context";
import { qk } from "shared/utils/qk";
import { graphql } from "src/gql";

export const SmsPreview = () => {
    const form = useComposeFormContext();

    const { data } = useQuery({
        queryFn: () => httpPostGraphql(query, { info: composeFormStateToDraftInfoInput.parse(form.getValues()) }),
        queryKey: qk("messages", "render-sms"),
    });

    return (
        <Stack>
            <Card padding="sm" withBorder style={{ height: "fit-content" }}>
                {data?.preview && <Textarea readOnly autosize variant="unstyled" value={data?.preview ?? ""} aria-label="SMS preview" />}
            </Card>
            <PropertyBadge title="SMS Characters Remaining">{1600 - (data?.preview.length ?? 0)}</PropertyBadge>
        </Stack>
    );
};

const query = graphql(`
    query SmsPreview($info: DraftInfoInput!) {
        preview: renderDraftAsSMS(info: $info)
    }
`);
